const fraudDetector = {
  err_fraud_detector_not_enabled: {
    message: 'Fraud detector is not enabled for your account',
  },
  err_fraud_detector_save_failed: {
    message: 'Unable to save fraud detector settings. Please try again.',
  },
  err_fraud_detector_delete_failed: {
    message: 'Unable to remove fraud detector. Please try again.',
  },
  err_invalid_detection_mode: {
    message: 'Invalid detection mode selected',
  },
  err_survey_template_invalid: {
    message: 'Selected survey template is invalid',
  },

  err_ats_job_id_required: {
    message: 'Job ID is required',
  },
  err_ats_job_not_found: {
    message: 'Job not found',
  },
  err_ats_application_not_found: {
    message: 'Application not found',
  },
  err_background_verification_access_denied: {
    message: 'You do not have permission to perform fraud detection',
  },

  err_email_address_missing: {
    message:
      'Email address is mandatory for fraud detection. Add one and review them again.',
  },
  err_resume_required: {
    message: "Candidate's resume is required to run fraud detection",
  },
  err_resume_url_failed: {
    message: 'Failed to process the resume. Please re-upload and try again.',
  },
  err_phone_number_missing: {
    message: "Candidate's phone number is required to run fraud detection",
  },
  err_phone_country_code_missing: {
    message: "Candidate's phone country code is missing",
  },
  err_phone_number_invalid: {
    message:
      "Candidate's phone number is invalid. Please update and try again.",
  },
  err_credit_cap_exceeded: {
    message:
      'Credit limit reached. Please contact your admin to add more credits.',
  },
  CREDIT_CAP_EXCEEDED: {
    message:
      'Credit limit reached. Please contact your admin to add more credits.',
  },
  err_background_verification_failed: {
    message: 'Fraud detection failed. Please try again.',
  },
  ACTIVE_VERIFICATION_EXISTS: {
    message: 'A fraud detection is already in progress for this candidate.',
  },
  err_already_verified: {
    message: 'This candidate has already been reviewed with fraud detector.',
  },

  err_verification_not_found: {
    message: 'Verification record not found',
  },
  err_override_only_for_completed: {
    message: 'Status can only be overridden for completed verifications',
  },
  err_invalid_risk_level: {
    message: 'Invalid risk level provided',
  },
  err_override_failed: {
    message: 'Failed to override verification status. Please try again.',
  },

  err_bulk_params_required: {
    message: 'Required parameters are missing for bulk verification',
  },
  err_bulk_credit_cap_exceeded: {
    message:
      'Credit limit reached for bulk verification. Please contact your admin.',
  },
  err_no_valid_verifications: {
    message: 'No valid candidates to run fraud detection on',
  },
  err_bulk_submission_failed: {
    message: 'Bulk fraud detection submission failed. Please try again.',
  },

  err_bulk_group_not_found: {
    message: 'Bulk verification group not found',
  },
  err_incomplete_schedule: {
    message: 'Incomplete schedule: scheduled time and timezone are required',
  },
  err_scheduled_at_invalid: {
    message: 'Scheduled time must be a valid 24-hour time format',
  },
  err_scheduled_at_timezone_invalid: {
    message: 'Selected timezone is invalid',
  },
  err_ats_rejection_reason_required: {
    message: 'Rejection reason is required',
  },
  err_email_template_required: {
    message: 'Email template is required',
  },
  err_email_sender_required: {
    message: 'Email sender is required',
  },
  err_email_subject_required: {
    message: 'Email subject is required',
  },
  err_email_body_required: {
    message: 'Email body is required',
  },
  err_survey_link_requires_form_template: {
    message: 'Survey link requires a form template',
  },
};

export const handleFraudDetectorError = (errorKey, result) => {
  const errorString = errorKey || result?.errors?.[0];

  if (typeof errorString === 'string') {
    if (
      errorString.includes('Incomplete schedule') ||
      errorString.includes('scheduled_at') ||
      errorString.includes('scheduled_at_timezone')
    ) {
      if (errorString.includes('scheduled_at must be a valid 24-hour time')) {
        return 'Scheduled time must be a valid 24-hour time format';
      }
      if (errorString.includes('scheduled_at_timezone is invalid')) {
        return 'Selected timezone is invalid';
      }
      if (errorString.includes('Incomplete schedule')) {
        return 'Incomplete schedule: scheduled time and timezone are required';
      }
    }
  }

  return null;
};

export default fraudDetector;
